import { useState, useEffect } from 'react'
import { doc, getDoc } from 'firebase/firestore'
import {
  MedicalData,
  InjuryData,
  SurgeryData,
  ChildhoodVaccineData,
  AdultVaccineData,
  AllergyData,
} from '../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

export const useMedicalHistoryData = (uid: string) => {
  const [medicalHistory, setMedicalHistory] = useState<MedicalData[]>([])
  const [initialMedicalHistory, setInitialMedicalHistory] = useState<
    MedicalData[]
  >([])

  const [injuryHistory, setInjuryHistory] = useState<InjuryData[]>([])
  const [initialInjuryHistory, setInitialInjuryHistory] = useState<
    InjuryData[]
  >([])

  const [surgeryHistory, setSurgeryHistory] = useState<SurgeryData[]>([])
  const [initialSurgeryHistory, setInitialSurgeryHistory] = useState<
    SurgeryData[]
  >([])

  const [childhoodVaccineHistory, setChildhoodVaccineHistory] = useState<
    ChildhoodVaccineData[]
  >([])
  const [initialChildhoodVaccineHistory, setInitialChildhoodVaccineHistory] =
    useState<ChildhoodVaccineData[]>([])

  const [adultVaccineHistory, setAdultVaccineHistory] = useState<
    AdultVaccineData[]
  >([])
  const [initialAdultVaccineHistory, setInitialAdultVaccineHistory] = useState<
    AdultVaccineData[]
  >([])

  const [allergyHistory, setAllergyHistory] = useState<AllergyData[]>([])
  const [initialAllergyHistory, setInitialAllergyHistory] = useState<
    AllergyData[]
  >([])

  useEffect(() => {
    const fetchMedicalHistory = async () => {
      if (!uid) return alert('Not logged in!')

      const userRef = doc(getEffectiveServices().firestore, 'users', uid)
      const userDoc = await getDoc(userRef)

      if (userDoc.exists()) {
        const data = userDoc.data()
        const fetchedMedicalHistory = data.medicalDetails?.medicalHistory || []
        const fetchedInjuryHistory = data.medicalDetails?.injuryHistory || []
        const fetchedSurgeryHistory = data.medicalDetails?.surgeryHistory || []
        const fetchedChildhoodVaccineHistory =
          data.medicalDetails?.childhoodVaccineHistory || []
        const fetchedAdultVaccineHistory =
          data.medicalDetails?.adultVaccineHistory || []
        const fetchedAllergyHistory = data.medicalDetails?.allergyHistory || []

        setMedicalHistory(fetchedMedicalHistory)
        setInitialMedicalHistory(fetchedMedicalHistory)
        setInjuryHistory(fetchedInjuryHistory)
        setInitialInjuryHistory(fetchedInjuryHistory)
        setSurgeryHistory(fetchedSurgeryHistory)
        setInitialSurgeryHistory(fetchedSurgeryHistory)
        setChildhoodVaccineHistory(fetchedChildhoodVaccineHistory)
        setInitialChildhoodVaccineHistory(fetchedChildhoodVaccineHistory)
        setAdultVaccineHistory(fetchedAdultVaccineHistory)
        setInitialAdultVaccineHistory(fetchedAdultVaccineHistory)
        setAllergyHistory(fetchedAllergyHistory)
        setInitialAllergyHistory(fetchedAllergyHistory)
      }
    }

    fetchMedicalHistory()
  }, [uid])

  return {
    // Medical History
    medicalHistory,
    setMedicalHistory,
    initialMedicalHistory,

    // Injury History
    injuryHistory,
    setInjuryHistory,
    initialInjuryHistory,

    // Surgery History
    surgeryHistory,
    setSurgeryHistory,
    initialSurgeryHistory,

    // Childhood Vaccine History
    childhoodVaccineHistory,
    setChildhoodVaccineHistory,
    initialChildhoodVaccineHistory,

    // Adult Vaccine History
    adultVaccineHistory,
    setAdultVaccineHistory,
    initialAdultVaccineHistory,

    // Allergy History
    allergyHistory,
    setAllergyHistory,
    initialAllergyHistory,
  }
}

export default useMedicalHistoryData
